import request from '@/utils/ai-train-request'
import { Message } from 'element-ui'
import { recordParams } from '@/utils/ai-train-data'

// AI训战 - 记录（ai_session + ai_evaluation）+ 导出 + 重新评分 + DeepSeek 月度用量
// 三个字面路径均由任务书 §3.2 给出，照抄，一个字不改：
//   POST /admin/record/export
//   POST /admin/session/{id}/re-evaluate
//   GET  /admin/usage/monthly
const apiPath = '/admin/record'

const aiTrainRecordApi = {
  fetchList(query) {
    return request({ url: apiPath, method: 'get', params: recordParams(query) })
  },
  fetchDetail(sessionId) {
    return request({ url: `${apiPath}/${encodeURIComponent(sessionId)}`, method: 'get' })
  },
  /**
   * 提交异步导出任务（"落 sys_task 同款"：本工程自建库不共享主系统 sys_task 表，
   * 这里只按同样的"提交任务→轮询状态→拿下载链接"模式实现，见 record/index.vue）
   */
  export(query) {
    return request({ url: `${apiPath}/export`, method: 'post', data: recordParams(query) })
  },
  /**
   * 导出任务列表（用于轮询状态/展示下载链接）—— 任务书未给具体路径，自定
   */
  fetchExportTasks() {
    return request({ url: `${apiPath}/export/tasks`, method: 'get' })
  },
  download(id) {
    // 固定本服务路径，避免相对 href 绕过 AI baseURL 和 Token 请求拦截器。
    return request({ url: `${apiPath}/export/download/${encodeURIComponent(id)}`, method: 'get', responseType: 'blob' })
      .then(async response => {
        const type = (response.headers && response.headers['content-type']) || (response.data && response.data.type) || ''
        if (type.includes('json')) {
          const text = await new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsText(response.data)
          })
          let message = '导出下载失败，请重试'
          try { const body = JSON.parse(text); message = body.msg || body.message || message } catch (_) { /* 保留失败提示 */ }
          Message({ message, type: 'error' })
          throw new Error(message)
        }
        if (!(response.data instanceof Blob) || (!type.includes('text/csv') && !type.includes('application/octet-stream'))) {
          const message = '导出返回内容不是CSV文件，请重试'
          Message({ message, type: 'error' })
          throw new Error(message)
        }
        return response.data
      })
  },
  reEvaluate(sessionId) {
    return request({ url: `/admin/session/${sessionId}/re-evaluate`, method: 'post' })
  },
  fetchMonthlyUsage(month) {
    return request({ url: '/admin/usage/monthly', method: 'get', params: { month } })
  }
}

export default aiTrainRecordApi
